import { AxiosPromise } from 'axios';

const pendingRequest = new Map<string, AxiosPromise<any>>();
const MAX_PENDING_SIZE = 100;

// 清理策略：当 Map 超过最大容量时，删除最早的请求
const cleanupPendingMap = () => {
  if (pendingRequest.size > MAX_PENDING_SIZE) {
    const firstKey = pendingRequest.keys().next().value;
    if (firstKey) pendingRequest.delete(firstKey);
  }
};

// 确保请求键被清理
const removePendingRequest = (key: string) => {
  pendingRequest.delete(key);
};

export const requestDedupe = {
  has(key: string) { return pendingRequest.has(key); },
  get(key: string) { return pendingRequest.get(key); },
  set(key: string, promise: AxiosPromise<any>) { pendingRequest.set(key, promise); },
  delete(key: string) { removePendingRequest(key); },
  cleanup() { cleanupPendingMap(); },
};